import { StatusPill } from "@/components/StatusPill";
import { fmtDate, money } from "@/lib/api";
import { CLAIM_LABEL, claimTypeLabel } from "@/lib/constants";

export const ClaimsList = ({ claims }) => (
  <div className="grid gap-3" data-testid="claims-list">
    {claims.map((c) => {
      const last = c.history[c.history.length - 1];
      return (
        <div key={c.id} className="rounded-lg border border-slate-200 bg-white p-5" data-testid={`claim-card-${c.id}`}>
          <div className="flex flex-col gap-2 md:flex-row md:items-start md:justify-between">
            <div>
              <p className="font-mono text-sm text-slate-500" data-testid={`claim-number-${c.id}`}>{c.claim_number} · Policy {c.policy_number}</p>
              <p className="mt-1 font-semibold">{claimTypeLabel(c.coverage_type, c.incident_type)} · {fmtDate(c.incident_date)}</p>
              <p className="text-sm text-slate-500">{c.location} · Filed {fmtDate(c.created_at)}</p>
              {c.adjuster && <p className="mt-1 text-sm text-slate-600" data-testid={`claim-adjuster-${c.id}`}>Claims adjuster: {c.adjuster}</p>}
              {last?.note && <p className="mt-2 text-sm text-slate-700" data-testid={`claim-note-${c.id}`}>Latest update: {last.note}</p>}
            </div>
            <div className="flex items-center gap-3">
              {c.payout != null && <p className="font-mono font-semibold" data-testid={`claim-payout-${c.id}`}>{money(c.payout)}</p>}
              <StatusPill status={c.status} label={CLAIM_LABEL[c.status]} testId={`claim-status-${c.id}`} />
            </div>
          </div>
        </div>
      );
    })}
  </div>
);
